module.exports = __webpack_public_path__ + "SP_SPS1-Basketball-4373f3a2ce5fa7a8120780a8a6b80e7d.png";